import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
export const showSocialLoginOptions = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showSocialLoginOptions.url(options),
    method: 'get',
})

showSocialLoginOptions.definition = {
    methods: ["get","head"],
    url: '/user/social-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
showSocialLoginOptions.url = (options?: RouteQueryOptions) => {
    return showSocialLoginOptions.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
showSocialLoginOptions.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showSocialLoginOptions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
showSocialLoginOptions.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showSocialLoginOptions.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
const showSocialLoginOptionsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showSocialLoginOptions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
showSocialLoginOptionsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showSocialLoginOptions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::showSocialLoginOptions
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:52
* @route '/user/social-login'
*/
showSocialLoginOptionsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showSocialLoginOptions.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showSocialLoginOptions.form = showSocialLoginOptionsForm

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
export const getSocialLoginStatus = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getSocialLoginStatus.url(options),
    method: 'get',
})

getSocialLoginStatus.definition = {
    methods: ["get","head"],
    url: '/user/social-login-status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
getSocialLoginStatus.url = (options?: RouteQueryOptions) => {
    return getSocialLoginStatus.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
getSocialLoginStatus.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getSocialLoginStatus.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
getSocialLoginStatus.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getSocialLoginStatus.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
const getSocialLoginStatusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getSocialLoginStatus.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
getSocialLoginStatusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getSocialLoginStatus.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\SocialiteInertiaController::getSocialLoginStatus
* @see app/Http/Controllers/User/Auth/SocialiteInertiaController.php:147
* @route '/user/social-login-status'
*/
getSocialLoginStatusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getSocialLoginStatus.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

getSocialLoginStatus.form = getSocialLoginStatusForm

const SocialiteInertiaController = { showSocialLoginOptions, getSocialLoginStatus }

export default SocialiteInertiaController